module.exports = __webpack_public_path__ + "static/media/icon-game.aa5b2216.svg";